import React from "react";
import cn from "classnames";
import dayjs from "dayjs";
import classNames from "classnames";
import { Icon } from "../Icon/Icon";
import Button from "../Button";
const MonthSelector = ({ className, kind, selectedMonth, onNextMonth, onPrevMonth, onNextYear, onPrevYear, minMonth, maxMonth, disabled, dataCySuffix, ...rest }) => {
    const selectedMonthDayJs = dayjs(selectedMonth);
    const year = selectedMonthDayJs.format("YYYY");
    const month = selectedMonthDayJs.format(kind === "desktop"
        ? "MMMM YYYY"
        : kind === "popup"
            ? "MMMM"
            : selectedMonthDayJs.year() !== dayjs().year()
                ? "MMMM YYYY"
                : "MMMM");
    const disablePrevMonth = (minMonth != null &&
        minMonth >= selectedMonthDayJs.startOf("month").format("YYYY-MM-DD")) ||
        disabled;
    const disableNextMonth = (maxMonth != null &&
        maxMonth <= selectedMonthDayJs.endOf("month").format("YYYY-MM-DD")) ||
        disabled;
    const disablePrevYear = (minMonth != null &&
        minMonth >= selectedMonthDayJs.startOf("year").format("YYYY-MM-DD")) ||
        disabled;
    const disableNextYear = (maxMonth != null &&
        maxMonth <= selectedMonthDayJs.endOf("year").format("YYYY-MM-DD")) ||
        disabled;
    const dataCy = (name) => {
        return dataCySuffix ? `${name}-${dataCySuffix}` : name;
    };
    const dataCyProps = {
        root: dataCy("ukt-monthselector"),
        year: dataCy("ukt-monthselector-year"),
        yearPrev: dataCy("ukt-monthselector-year-prev-btn"),
        yearNext: dataCy("ukt-monthselector-year-next-btn"),
        month: dataCy("ukt-monthselector-month"),
        monthPrev: dataCy("ukt-monthselector-month-prev-btn"),
        monthNext: dataCy("ukt-monthselector-month-next-btn"),
    };
    return (React.createElement("div", { className: cn("ukt-monthselector", className), ...rest, "data-cy": dataCyProps.root },
        kind === "popup" && (React.createElement("div", { className: cn("year_selector typography-label mx-auto mb-1 flex w-fit items-center justify-center gap-6 text-gray-text-color"), "data-cy": dataCyProps.year, "aria-live": "polite" },
            React.createElement(Arrow, { className: "icon-sm ml-1 mr-auto", icon: "chevron-left", ariaLabel: "Select previous year", onClick: onPrevYear, disabled: disablePrevYear, "data-cy": dataCyProps.yearPrev }),
            year,
            React.createElement(Arrow, { className: "icon-sm mr-1 ml-auto", icon: "chevron-right", ariaLabel: "Select next year", onClick: onNextYear, disabled: disableNextYear, "data-cy": dataCyProps.yearNext }))),
        React.createElement("div", { className: classNames("typography-h2 flex flex-row items-center justify-between", kind === "mobile" && "rounded-xl bg-card-color px-2 py-4 shadow-big"), "data-cy": dataCyProps.month, "aria-live": "polite" },
            React.createElement(Arrow, { ariaLabel: "Select previous month", icon: "chevron-left", className: "mr-auto", onClick: onPrevMonth, disabled: disablePrevMonth, "data-cy": dataCyProps.monthPrev }),
            month,
            React.createElement(Arrow, { ariaLabel: "Select next month", className: "ml-auto", icon: "chevron-right", onClick: onNextMonth, disabled: disableNextMonth, "data-cy": dataCyProps.monthNext })),
        kind !== "mobile" && (React.createElement("div", { className: classNames("h-[1px] w-full bg-separator-color", kind === "desktop" ? "my-4" : "my-2") }))));
};
const Arrow = ({ icon, onClick, disabled, className, ariaLabel }) => (React.createElement(Button, { kind: "icon", ariaLabel: ariaLabel, onClick: onClick, disabled: disabled },
    React.createElement(Icon, { className: cn(`icon ${icon}-icon`, !disabled && "!bg-main-color hover:!bg-dark-main-color", className, {
            "!cursor-not-allowed opacity-60": disabled,
        }) })));
export default MonthSelector;
//# sourceMappingURL=MonthSelector.js.map